import { FieldTypeRegistryService } from './field-type-registry.service';
import {
    TextFieldComponent,
    TextareaFieldComponent,
    NumberFieldComponent,
    CheckboxFieldComponent,
    TimeFieldComponent,
    DateFieldComponent,
    UserSelectFieldComponent,
    CrewMemberFieldComponent,
    DropdownFieldComponent,
    SectionHeaderFieldComponent,
    TaskListFieldComponent,
    FileUploadFieldComponent,
    TechnicalItemFieldComponent
} from './strategies';

/**
 * Factory function that registers all built-in field types.
 * Used as an APP_INITIALIZER to ensure field types are available
 * before any dynamic fields are rendered.
 *
 * To add a custom field type:
 * 1. Create a component that extends BaseFieldComponent
 * 2. Add registry.register('YOUR_TYPE', YourComponent) here
 * 3. Add the type to the FieldType union in templates-admin.model.ts
 */
export function initializeFieldTypes(registry: FieldTypeRegistryService): () => void {
    return () => {
        // Text inputs
        registry.register('TEXT', TextFieldComponent);
        registry.register('TEXTAREA', TextareaFieldComponent);
        registry.register('NUMBER', NumberFieldComponent);

        // Selection inputs
        registry.register('CHECKBOX', CheckboxFieldComponent);
        registry.register('DROPDOWN', DropdownFieldComponent);
        registry.register('USER_SELECT', UserSelectFieldComponent);
        registry.register('CREW_MEMBER', CrewMemberFieldComponent);

        // Date/time inputs
        registry.register('TIME', TimeFieldComponent);
        registry.register('DATE', DateFieldComponent);

        // Structural fields
        registry.register('SECTION_HEADER', SectionHeaderFieldComponent);

        // Complex fields
        registry.register('TASK_LIST', TaskListFieldComponent);
        registry.register('FILE_UPLOAD', FileUploadFieldComponent);
        registry.register('TECHNICAL_ITEM', TechnicalItemFieldComponent);
    };
}
